export default __webpack_public_path__ + "static/media/codecov.d0ae326d.svg";